<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="assessment-page-title" class="mb-1">
      <!-- <button class="btn btn-secondary-dark float-right"
              @click="filterOpened = !filterOpened"
              qid="assessment-filter-button"
      >
        <font-awesome-icon icon="filter"/>
      </button> -->
      <!-- <router-link
          to="/maintenance/assessment-templates/create"
          class="btn btn-success float-right"
          qid="create-a-button"
          v-if="isGranted(permissions.ASSESSMENT_CREATE)"
      > -->
      <span v-if="isGranted(permissions.ASSESSMENT_CREATE)"
            class="btn btn-success float-right"
            qid="a-create-button"
            @click="showCreateAModal()"
      >
        <font-awesome-icon icon="plus-circle"/> {{ $t('maintenance.assessments.create_button') }}
      </span>
      <b-form-input
          type="text"
          v-model="filters.keywordValue"
          class="float-right mw-300 mr-3 search-bar"
          v-on:input="debounceInput"
          :placeholder="$t('maintenance.assessments.search_placeholder')"
          qid="a-search-input"
      ></b-form-input>
      {{ $t('maintenance.assessments.title') }}
    </h4>
    <div>
      <span v-if="getGuide('assessment_templates_list')">
        <GuideButton :guide="getGuide('assessment_templates_list')"></GuideButton>
      </span>
    </div>

    <div class="row mt-4" :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-10 table-container">
        <div class="">
          <table class="table table-responsive-md table-list">
            <thead>
            <tr>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('name')"
                  qid="sort-a-name"
              >
                {{ $t('maintenance.assessments.table.name') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                </span>
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('type')"
                  qid="sort-a-name"
              >
                {{ $t('projects.table.type') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'type'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'type'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'type'"/>
                </span>
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('scope')"
                  qid="sort-a-name"
              >
                {{ $t('projects.table.scope') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'scope'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'scope'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'scope'"/>
                </span>
              </th>
              <th scope="col"
                  class="cursor-pointer"
                  @click="selectSort('updated_at')"
                  qid="sort-a-name"
              >
                {{ $t('system.last_updated') }}
                <span class="ml-2">
                  <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                  <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                  <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
                </span>
              </th>
              <th width="130"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(object, index) in tableItems" :key="'table-row-' + index" :id="'table-row-' + index">
                <b-popover
                    :target="'table-row-' + index"
                    boundary="viewport"
                    triggers="hover"
                    placement="topleft"
                    :delay="{ show: 500, hide: 0 }"
                >
                  <div v-if="object.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.assessments.create.description_label') }}:
                    </span>
                    <br>
                    {{ object.description | truncate(200)}}
                    <br>
                  </div>
                </b-popover>

                <td>
                  <router-link
                      :to="{ name: 'maintenance.assessments.view', params: { slug: object.slug }}"
                      qid="a-view-page-link"
                  >
                    {{ object.name }}
                  </router-link>
                </td>
                <td class="">
                  <span qid="a-type" class="badge" v-if="object.type">
                    <font-awesome-icon icon="file-alt" class="mr-1"/>
                    {{ $t('maintenance.assessments.type.' + $options.filters.slugify(object.type)) }}
                  </span>
                </td>
                <td class="">
                  <span qid="a-type" class="badge" v-if="object.scope && (object.type == 'risk' || object.type == 'bia')">
                    <font-awesome-icon icon="crosshairs" class="mr-1"/>
                      {{ $t('projects.scope.' + $options.filters.slugify(object.scope)) }}
                  </span>
                  <span qid="a-type" class="badge" v-else>
                      {{ $t('system.n_a') }}
                  </span>
                </td>
                <td>
                  <span>
                    <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                    {{ object.updated_at | formatDate }}
                  </span>
                </td>
                <td>
                  <span v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                        class="btn btn-edit"
                        qid="edit-a-modal"
                        @click="showEditAModal(object)"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  <span v-if="isGranted([permissions.ASSESSMENT_DELETE, permissions.ASSESSMENT_DELETE_OWN], object.created_by) && (!getClient.parent || (getClient.parent && object.partition))"
                        class="btn btn-delete"
                        qid="delete-a-modal"
                        @click="showConfirmDeleteModal(object)"
                  >
                    <font-awesome-icon icon="trash-alt"/>
                  </span>
                </td>
              </tr>
              <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-3 pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    label="value"
                    qid="create-org-form-organization-level"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- Delete Assessment Template confirm modal template -->
    <b-modal ref="delete-assessment" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="delete-a-title">
            {{ $t('maintenance.assessments.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.assessments.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.assessments.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideConfirmDeleteModal"
                            qid="delete-a-cancel-button"
                  >
                    {{ $t('maintenance.assessments.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteA(itemToDelete)"
                            class="ml-3"
                            variant="danger"
                            qid="delete-a-submit-button"
                            v-if="isGranted([permissions.ASSESSMENT_DELETE, permissions.ASSESSMENT_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                  >
                    {{ $t('maintenance.assessments.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Edit Assessment Template modal template -->
    <b-modal ref="edit-assessment" @hide="hideEditAModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditAModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-a-title">
            {{ $t('maintenance.assessments.update.title') }}
          </h5>
          <div class="row mt-3 pt-4 pb-1 pl-5 pr-5">
            <div class="col-sm-12"
                 v-if="getGuide('update_assessment_template')"
            >
              <b-form-group>
                <div class="">
                  <label qid="create-p-users-label">
                    <GuideButton :guide="getGuide('update_assessment_template')"></GuideButton>
                  </label>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-a-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editAFormSubmit" qid="edit-a-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-a-name-label">
              {{ $t('maintenance.assessments.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-a-form-name"
              type="text"
              v-model="form.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-a-description-label">
              {{ $t('maintenance.assessments.create.description_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-textarea
              qid="edit-a-form-description"
              v-model="form.description"
              rows="6"
              required
              max-rows="6"
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group v-if="type.value == 'bia'">
            <label qid="create-a-scope-label">
              {{ $t('projects.create.scope_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="scope"
                :options="scopes"
                :placeholder="$t('projects.create.scope_placeholder')"
                label="name"
                required
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-a-form-scope"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditAModal"
                            qid="edit-a-cancel-button"
                  >
                    {{ $t('maintenance.data_objects.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="edit-a-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.data_objects.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Create Assessment Template -->
    <b-modal ref="create-assessment" @hide="hideCreateAModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateAModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-a-title">
            {{ $t('maintenance.assessments.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-a-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createAFormSubmit" qid="create-a-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-a-name-label">
              {{ $t('maintenance.assessments.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="edit-a-form-name"
              type="text"
              v-model="form.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.assessments.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <label qid="edit-a-description-label">
              {{ $t('maintenance.assessments.create.description_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-textarea
              qid="edit-a-form-description"
              v-model="form.description"
              rows="6"
              required
              max-rows="6"
              :placeholder="$t('maintenance.assessments.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-a-type-label">
              {{ $t('projects.create.type_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="type"
                :options="types"
                :allow-empty="false"
                required
                :placeholder="$t('projects.create.type_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @input="onChangeType"
                qid="create-a-form-type"
            ></multiselect>
            <span class="text-muted" v-if="type.value == 'control'">
              * {{ $t('maintenance.assessments.type.control_explainer_text') }}
            </span>
            <span class="text-muted" v-if="type.value == 'risk'">
              * {{ $t('maintenance.assessments.type.risk_explainer_text') }}
            </span>
            <span class="text-muted" v-if="type.value == 'bia'">
              * {{ $t('maintenance.assessments.type.bia_explainer_text') }}
            </span>
          </b-form-group>

          <b-form-group v-if="type.value == 'risk' || type.value == 'bia'">
            <label qid="create-a-scope-label">
              {{ $t('projects.create.scope_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="scope"
                :options="scopes"
                :placeholder="$t('projects.create.scope_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-a-form-scope"
            ></multiselect>
          </b-form-group>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateAModal"
                            qid="create-a-cancel-button"
                  >
                    {{ $t('maintenance.data_objects.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-a-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.data_objects.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import Avatar from '@/components/Avatar.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'Assessments',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.assessments.title'),
            active: true
          }
        ],
        tableItems: [],

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,

        itemToDelete: {},
        form: {
          name: '',
          description: '',
          type: '',
          scope: '',
          client:'',
        },
        error: '',
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        filters: {
          type: '',
          scope: ''
        },
        type: [],
        types: [
          { name: this.$t('maintenance.assessments.type.control'), value: 'control' },
          { name: this.$t('maintenance.assessments.type.risk'), value: 'risk' },
          { name: this.$t('maintenance.assessments.type.bia'), value: 'bia' }
        ],
        scope: [],
        scopes: [],
        risk_scopes: [
          { name: this.$t('projects.scope.process'), value: 'process' },
          { name: this.$t('projects.scope.activity'), value: 'activity' },
          { name: this.$t('projects.scope.third_party'), value: 'third_party' },
        ],
        bia_scopes: [
          { name: this.$t('projects.scope.process'), value: 'process' },
          { name: this.$t('projects.scope.activity'), value: 'activity' }
        ],

        loading: true,
        buttonDisabled: false,
        showFullGuideDescription: false,
        wpGuide: {},
        myGuides: [],
      }
    },
    components: {
      Avatar,
      GuideButton
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadContent();
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadContent()
      }, 400),
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Maintenance' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      loadGuidesWP(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
      resetFilters() {
        this.filters.time_limit = '',
        this.debounceInput()
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      loadContent(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;
        piincHttp.get('/assessments', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
        }, function() {});
      },
      pageChanged(page) {
        this.loadContent(page)
      },
      perPageChanged(perPage) {
        let self = this;
        // Load content when page changed listener is triggered
        this.loadContent(1, perPage.value)
        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
      },
      perPageRemoved() {
        let self = this;
        // Load content when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadContent(1, self.selectedPerPage)
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-assessment'].show()
      },
      hideConfirmDeleteModal() {
        this.itemToDelete = {}
        this.$refs['delete-assessment'].hide()
      },
      showEditAModal(object) {
        let self = this;
        this.error = ''

        this.loadGuidesWP('update_assessment_template');

        if (object.type == 'risk') {
          this.scopes = this.risk_scopes;
        } else {
          if (object.type == 'bia') {
            this.scopes = this.bia_scopes;
          } else {
            this.scopes = [];
          }
        }

        this.type = []
        if (object.type) {
          this.type = _.find(this.types, function(item) {
            return item.value === object.type;
          });
        }

        this.scope = []
        if (object.scope) {
          this.scope = _.find(this.scopes, function(item) {
            return item.value === object.scope;
          });
        }

        this.form.slug = object.slug;
        this.form.name = object.name;
        this.form.description = object.description;
        this.$refs['edit-assessment'].show()
      },
      showCreateAModal(object) {
        let self = this;
        this.error = ''

        this.scope = []
        this.type = []
        this.form.name = '';
        this.form.description = '';
        this.$refs['create-assessment'].show()
      },
      hideEditAModal() {
        this.$refs['edit-assessment'].hide()
      },
      hideCreateAModal() {
        this.$refs['create-assessment'].hide()
      },
      onChangeType() {
        let self = this;

        this.scope = [];

        if (this.type.value == 'risk') {
          this.scopes = this.risk_scopes;
        } else {
          if (this.type.value == 'bia') {
            this.scopes = this.bia_scopes;
          } else {
            this.scopes = [];
          }
        }
      },
      createAFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.form.client = this.getClient.slug;

        this.form.type = this.type ? this.type.value : '';

        if(this.type.value == 'control' || this.type.value == 'risk') {
          this.form.question = 1
        }else{
          if(this.type.value == 'bia') {
            this.form.system_impact_assessment = 1
          }
        }

        this.form.scope = this.scope ? this.scope.value : '';

        if (this.type.value == 'control' || (this.type.value == 'risk' && this.scope && this.scope.value) || (this.type.value == 'bia' && this.scope && this.scope.value)) {
          piincHttp.post('assessments/', this.form).then(function(response) {
            self.hideCreateAModal();
            self.buttonDisabled = false;
            self.loadContent(self.currentPage);
            self.$toastr('success', self.$t('maintenance.assessments.create.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (!this.type || (this.type && !this.type.value)) {
            this.error += ' ' + this.$t('maintenance.assessments.create.type_error_message')
          }
          if (!this.scope || (this.scope && !this.scope.value)) {
            this.error += this.$t('maintenance.assessments.create.scope_error_message')
          }
        }
      },
      editAFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.form.client = this.getClient.slug;

        this.form.type = this.type ? this.type.value : '';
        this.form.scope = this.scope ? this.scope.value : '';

        if (this.type.value == 'control' || (this.type.value == 'risk' && this.scope && this.scope.value) || (this.type.value == 'bia' && this.scope && this.scope.value)) {
          piincHttp.put('/assessments/' + this.form.slug, this.form).then(function(response) {
            self.hideEditAModal();
            self.buttonDisabled = false;
            self.loadContent(self.currentPage);
            self.$toastr('success', self.$t('maintenance.assessments.update.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (!this.type || (this.type && !this.type.value)) {
            this.error += ' ' + this.$t('maintenance.assessments.create.type_error_message')
          }
          if (!this.scope || (this.scope && !this.scope.value)) {
            this.error += this.$t('maintenance.assessments.create.scope_error_message')
          }
        }
      },
      confirmDeleteA(object) {
        let self = this;
        piincHttp.delete('assessments/' + object.slug).then(function(response) {
          self.hideConfirmDeleteModal();
          self.loadContent(self.currentPage);
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.assessments.delete.success'))
        }, function() {});
      }
    },
    beforeRouteLeave(to, from, next) {
      let object = {
        type: 'assessments',
        filters: this.filters
      }
      this.$store.commit('storeActiveFilters', object);
      this.$store.commit('storePerPage', this.selectedPerPage);
      next()
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        // if (this.getFilters.assessments) {
        //   this.filters = this.getFilters.assessments
        // }
        this.loadContent();

        if (this.getClient.systemModule) {
          this.risk_scopes.push({ name: this.$t('projects.scope.system'), value: 'system' })
        }
      }
      this.loadGuides('assessment_templates_list');
    }
  }
</script>
